/** Back office "Data & privacy": export, retention and cancellation (ADR-0034). */
export const enDataLifecycle = {
  'bo.data.nav': 'Data & privacy',
  'bo.data.title': 'Data & privacy',
  'bo.data.subtitle':
    'Export everything stored for {tenant}, see how long each kind of data is kept, or cancel the subscription.',
  'bo.data.noPermission': 'Only the owner can export data or cancel the subscription.',

  'bo.data.export.title': 'Export all data',
  'bo.data.export.desc':
    'A ZIP file with one JSON Lines file per table — orders, bills, payments, stock ledger, suppliers, staff and the audit log. Ready within a few minutes; each download stays available for {days} days.',
  'bo.data.export.request': 'Request export',
  'bo.data.export.requesting': 'Requesting…',
  'bo.data.export.requested': 'Export requested. It appears below as soon as it is ready.',
  'bo.data.export.quota': '{used} of {limit} exports requested in the last 24 hours.',
  'bo.data.export.busy': 'An export is being prepared. You can request another once it is done.',
  'bo.data.export.empty': 'No exports yet — request one and it appears here within a few minutes.',
  'bo.data.export.sensitive':
    'The file contains personal data of your staff and guests. Store it securely and share it only with people who need it.',
  'bo.data.export.col.requested': 'Requested',
  'bo.data.export.col.by': 'Requested by',
  'bo.data.export.col.status': 'Status',
  'bo.data.export.col.size': 'Size',
  'bo.data.export.col.until': 'Available until',
  'bo.data.export.col.action': 'Download',
  'bo.data.export.download': 'Download',
  'bo.data.export.downloading': 'Preparing…',
  'bo.data.export.downloadAria': 'Download the export requested {date}',
  'bo.data.export.status.pending': 'Waiting',
  'bo.data.export.status.running': 'Preparing',
  'bo.data.export.status.ready': 'Ready',
  'bo.data.export.status.failed': 'Failed',
  'bo.data.export.status.expired': 'Expired',
  'bo.data.export.failedHint': 'Request a new export; if it keeps failing, contact support.',

  'bo.data.retention.title': 'How long data is kept',
  'bo.data.retention.desc':
    'Retention by type of data. Financial records and the audit log are never deleted while the subscription is active.',
  'bo.data.retention.afterCancel': 'All data after cancellation',
  'bo.data.retention.exports': 'Export downloads',
  'bo.data.retention.financial': 'Financial records (orders, bills, payments, stock)',
  'bo.data.retention.audit': 'Audit log',
  'bo.data.retention.guest': 'Guest names on takeaway and delivery orders',
  'bo.data.retention.sessions': 'Expired sign-in sessions',
  'bo.data.retention.days': '{count} days',
  'bo.data.retention.years': 'At least {count} years',
  'bo.data.retention.afterClosing': '{count} days after closing',
  'bo.data.retention.backups':
    'Deleted data can remain in database backups for up to {days} more days, after which it is gone for good.',

  'bo.data.cancel.title': 'Cancel subscription',
  'bo.data.cancel.desc': 'Stops the service for every branch and all staff.',
  'bo.data.cancel.explain':
    'Everyone except you is signed out and the restaurant can no longer take orders. Your data is kept for {days} days so you can export it, or ask support to restore the account. After that it is permanently deleted from the database and file storage.',
  'bo.data.cancel.button': 'Cancel subscription…',
  'bo.data.cancel.dialogTitle': 'Cancel the subscription of {tenant}?',
  'bo.data.cancel.dialogBody':
    'All data will be permanently deleted on {date}. Download an export first if you need your records.',
  'bo.data.cancel.reason': 'Reason for cancelling',
  'bo.data.cancel.reasonHint': 'Stored in the audit log.',
  'bo.data.cancel.reasonRequired': 'Enter a reason of at least 3 characters.',
  'bo.data.cancel.confirmLabel': 'Type {slug} to confirm',
  'bo.data.cancel.confirmMismatch': 'This does not match the account ID.',
  'bo.data.cancel.confirm': 'Cancel subscription',
  'bo.data.cancel.confirming': 'Cancelling…',
  'bo.data.cancel.keep': 'Keep subscription',
  'bo.data.cancel.done': 'Subscription cancelled. Your data is kept until {date}.',
  'bo.data.cancelled.title': 'Subscription cancelled',
  'bo.data.cancelled.body':
    'Cancelled on {cancelled}. All data will be permanently deleted on {deletion}. Contact support before then to restore the account.',
} as const;
